import moment from "moment";
import { WebRoutes } from "consts/enpoints/web";
import { Merchant as MerchantApi } from "features/ecommerce/api";
import type { Merchant as MerchantType } from "features/ecommerce/types";
import ShoppingPlatforms from "features/ecommerce/ShoppingPlatforms";
import { Merchant } from "ui/forms/ECommerce";
import { useOnboardingForm, useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useBusinessInformation = () => {
    const { getApplicationModel } = useOnboardingApplication();

    const { data } = useOnboardingStepData<MerchantType.OnboardingBusinessInformation>();

    const withValues = useOnboardingForm({
        save: MerchantApi.putOnboardingsBusinessInformationSteps,
        route: WebRoutes.Onboarding.Merchant,
        getApplicationModel
    });

    const formProps: Merchant.BusinessInformation.OnboardingBusinessInformationForm = {
        bootstrapData: {},
        initialValues: Merchant.BusinessInformation.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: ({
            companyName,
            registrationNumber,
            yearEstablished,
            websiteUrl,
            primaryLocation,
            countryOfIncorporation = [],
            countriesOfBusinessActivity = [],
            platforms = []
        }, helpers) => (
            withValues({
                companyName,
                registrationNumber,
                countryOfIncorporation: [countryOfIncorporation]
                    .filter(Boolean)
                    .flat()
                    .join(','),
                yearEstablished: String(moment(yearEstablished).year()),
                websiteUrl,
                primaryLocation,
                countriesOfBusinessActivity: countriesOfBusinessActivity.join(','),
                platforms: ShoppingPlatforms.make()
                    .fromArray(platforms)
                    .serialize()
            }, helpers)
        )
    };

    return {
        ...formProps,
        ...Merchant.BusinessInformation.useForm(formProps),
        ...data
    };
};

export default useBusinessInformation;
